import { render, staticRenderFns } from "./TeamStatisticsPossession.vue?vue&type=template&id=5cd97ca1"
import script from "./TeamStatisticsPossession.vue?vue&type=script&lang=js"
export * from "./TeamStatisticsPossession.vue?vue&type=script&lang=js"
import style0 from "./TeamStatisticsPossession.vue?vue&type=style&index=0&id=5cd97ca1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports